export default __webpack_public_path__ + "static/media/cross.aa843a9c.jpg";